import React from 'react';

// Note: The original SVG had fill="#000000" for paths, but the parent had fill="#01844B".
// Assuming the path fill should be the one controlled by props or a default.
const AlertTriangleIcon = ({ fill = "#01844B", className = "", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 25 24" fill={fill} className={className} {...props}>
        <path d="M12.5 2L1.5 21H23.5M12.5 6L20.03 19H4.97M11.5 10V14H13.5V10M11.5 16V18H13.5V16" stroke={fill} strokeWidth="0.5" /> {/* Adjusted to use fill for consistency, or use a specific color for paths */}
    </svg>
);
export default AlertTriangleIcon;